import { useState } from "react";

function StartCourseBtn({ onClick }) {
  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked(true); // Fill the circle when clicked
    if (onClick) onClick(); // Notify parent
  };

  return (
    <button className="kursvaljarestart-course-btn" onClick={handleClick}>

      Börja kursväljaren, klicka här!
{/*       <span className={`kursvaljarecircle ${isChecked ? "kursvaljarechecked" : ""}`}>
        {isChecked && "✔"}
      </span> */}
    </button>
  );
}

export default StartCourseBtn;
